import { render, staticRenderFns } from "./SelectStaff.vue?vue&type=template&id=61c5a233"
import script from "./SelectStaff.vue?vue&type=script&lang=js"
export * from "./SelectStaff.vue?vue&type=script&lang=js"
import style0 from "./SelectStaff.vue?vue&type=style&index=0&id=61c5a233&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports